import { createEventAnnouncementRenderers } from '../announcements/eventAnnouncementRenderers';
import { createEventMessageContentRenderer } from './eventMessageContentRendererFactory';

export function createEventMessageRenderPipeline({
  announcementRendererOptions = {},
  contentRendererOptions = {},
}) {
  const announcementRenderers = createEventAnnouncementRenderers(announcementRendererOptions);
  const renderMessageContent = createEventMessageContentRenderer({
    ...contentRendererOptions,
    renderTimetableRuntimeCard: announcementRenderers.renderTimetableRuntimeCard,
    renderAnnouncementCard: announcementRenderers.renderAnnouncementCard,
  });

  return {
    ...announcementRenderers,
    renderMessageContent,
  };
}
